import { generateUUID } from "shared/lib/generateUUID"
import { useRequestActions } from "shared/lib/request-monitoring/store/useRequestActions"
import { useEvent } from "shared/lib/useEvent"
import { ProjectsAPIMutationType } from "shared/types/ProjectMutations"

export function useProjectRequestMonitor() {
  const { startProjectRequest, finishProjectRequest } = useRequestActions()

  const start = useEvent(
    ({
      projectID,
      requestType
    }: {
      projectID: string
      requestType: ProjectsAPIMutationType
    }) => {
      const requestID = generateUUID()
      startProjectRequest({ requestID, projectID, requestType })
      return () => finishProjectRequest({ requestID, projectID, requestType })
    }
  )

  return start
}
